type FormattableAddress = {
  name: string;
  line1: string;
  line2: string;
  town: string;
  county: string;
  postcode: string;
  country?: string;
};

export const formatFullAddress = (address: FormattableAddress): string => {
  return [address.name, address.line1, address.town, address.postcode].filter((line) => line && line.trim()).join(', ');
};
